module.exports = __webpack_public_path__ + "static/media/x.c1e52d31.svg";